module.exports = __webpack_public_path__ + "img/c_4.1c558d0f.jpg";